module.exports = __webpack_public_path__ + "1.0.0-fa265927/img/offline-vault-4.ccb41fd3.svg";